module.exports = __webpack_public_path__ + "static/img/relief04.56b26bf.bmp";


//////////////////
// WEBPACK FOOTER
// ./src/views/reliefVase/imgs/relief04.bmp
// module id = NvHp
// module chunks = 2